import type { VoidFunctionComponent } from 'react';
import Section from '../../../shared/settings/SettingsPageSection';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import type { GenericIssueSettingsProps } from './types';

/**
 * ProjectLicensingIssuesSettings
 */
const ProjectLicensingIssuesSettings: VoidFunctionComponent<GenericIssueSettingsProps> = (props) => {
  return (
    <Section>
      <Section.Left heading="Licensing">
        <Section.Paragraph>Configuration for licensing issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Licensing}
          scopeType={IssueScopeKind.Project}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectLicensingIssuesSettings;
